export default {
  methods: {
    compressImage (result, quality = 0.7, maxWidth = 1024) {
      return new Promise((resolve) => {
        const img = new Image()
        img.src = result
        img.onload = () => {
          // Calcular proporções
          let width = img.width 
          let height = img.height
          if (width > maxWidth) { 
            height = (maxWidth / width) * height
            width = maxWidth
          }
   
          // Criar canvas
          const canvas = document.createElement("canvas")
          canvas.width = width
          canvas.height = height
          const ctx = canvas.getContext("2d")
          ctx.drawImage(img, 0, 0, width, height)
   
          // Compactar
          const dataUrl = canvas.toDataURL("image/jpeg", quality)
          resolve(dataUrl)
        }
      })
    }
  }
}
